<template>
  <v-container fluid>
    <div class="modal-padding myt-modal">
      <div class="close-outer" @click="onClose({ status: false })">
        <img src="../../../assets/img/close-icon.svg" class="close-icon" />
      </div>
      <v-row>
        <v-col cols="12" sm="12">
          <div class="myt-center-name">Hello!</div>
          <div class="enter-text-title myt-btm-20">
            Please tell us a bit about you
          </div>
          <div class="myt-input-outer register-form-err">
            <v-text-field
              label="Name"
              dense
              outlined
              hide-details
              v-model="name"
            ></v-text-field>
          </div>
          <InputError :data="error.name"/>
          <div class="myt-input-outer register-form-err">
            <v-text-field
              label="Email"
              v-model="email"
              dense
              outlined
              hide-details
            ></v-text-field>
          </div>
          <InputError :data="error.email" />

          <div class="myt-dropdown add-ch-arrow">
            <div class="practice-session-drop-down">
              <div class="field-data myt-input-outer myt-user-type">
                <v-select
                  v-model="selectedRole"
                  @change="onRoleSelect"
                  :items="items"
                  label="User Type"
                  hide-details
                  dense
                  outlined
                  class="fix-140-width"
                ></v-select>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="12">
          <div class="center-right-alignn">
            <v-btn class="right-btn cust-btn" color="primary" @click="onSubmit"
              >Register</v-btn
            >
          </div>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>
<script>
import { mapActions, mapState } from "vuex";
import constants from "@/utils/constants.js";

export default {
  name: "signup",
  props: ["data", "onClose"],
  data() {
    return {
      items: [],
      // isCoordinator: false,
      isDeo: false,
      email: "",
      name: "",
      selectedRole: "",
      ischecked: false,
      error: {
        email: {
          type: null,
          message: null,
        },
        name: {
          type: null,
          message: null,
        },
        role: {
          type: null,
          message: null,
        },
      },
      showPrivacyAndTerms: true,
    };
  },

  methods: {
    ...mapActions({
      getExternalRoles: "userStore/getExternalRoles",
      signupMyt: "userStore/signupMyt",
      setSignUpData: "userStore/setSignUpData",
      validateEmail: "userStore/validateEmail",
    }),
    onRoleSelect(e) {
      if (e) {
        this.isCoordinator = e.role_code === this.roles.CO_ROLE_CODE;
        this.isStudent = e.role_code === this.roles.ST_ROLE_CODE;
        this.isParent = e.role_code === this.roles.PA_ROLE_CODE;
        this.isTeacher = e.role_code === this.roles.TE_ROLE_CODE;
        this.isDeo = e.role_code === this.roles.EDEO_ROLE_CODE;
        this.error.role.type = null;
      }
    },
    onSubmit() {
      if (this.validate()) {
        this.$root.showLoader = true;
        let creatorId = localStorage.getItem('guest_user_id')
        this.signupMyt({
          name: this.name.trim(),
          email: this.email,
          role_id: this.selectedRole.id,
          phone: this.data.phone,
          user_id:creatorId
        })
          .then((response) => {
            this.$root.showLoader = false;      
            localStorage.removeItem("guest_user_id");
            this.onClose({ status: false, isClearData: true,openDownloadPopup:this.data.openDownloadPopup,test:this.data.test });
          })
          .catch((err) => {
            this.$root.showLoader = false;
          });
      }
    },
    validate() {
      let isValid = true;
      this.error.name.type = null;
      this.error.email.type = null;
      this.email = this.removeWhiteSpacesFromEmail(this.email);
      if (!this.name || this.name.trim().length < 1) {
        this.error.name.type = "error";
        this.error.name.message = "Please enter name";
        isValid = false;
      } else if (this.name && this.name.trim().length > 70) {
        this.error.name.type = "error";
        this.error.name.message =
          "Name should not contain more than 70 characters";
        isValid = false;
      }
      if (!this.email || this.email.length < 1) {
        this.error.email.type = "error";
        this.error.email.message = "Please enter email ID.";
        isValid = false;
      } else if (!this.isValidEmail(this.email)) {
        this.error.email.type = "error";
        this.error.email.message = "Please enter a valid email ID.";
        isValid = false;
      }
      return isValid;
    },
  },
  mounted() {
    //   this.showPrivacyAndTerms = !constants.CUSTOM_DOMAIN_ID.includes(instiute.id)
    if (this.signUpData) {
      this.email = this.signUpData.email;
      this.name = this.signUpData.name;
      this.selectedRole = this.signUpData.selectedRoleForPreSelect;

      if (this.signUpData.selectedRoleForPreSelect) {
        let e = this.signUpData.selectedRoleForPreSelect;
        if (e) {
          this.isCoordinator = e.role_code === this.roles.CO_ROLE_CODE;
          this.isStudent = e.role_code === this.roles.ST_ROLE_CODE;
          this.isParent = e.role_code === this.roles.PA_ROLE_CODE;
          this.isTeacher = e.role_code === this.roles.TE_ROLE_CODE;
          this.isDeo = e.role_code === this.roles.EDEO_ROLE_CODE;
        }
      }
    }
    this.getExternalRoles({mytUser: true})
      .then((response) => {
        this.loading = false;
        this.items = response
          .filter((r) => r.role_code !== this.roles.ID_ROLE_CODE)
          .map((x) => {
            let role = {};
            role.text = x.role_name;
            role.value = x;
            if (x.id === this.roleIds.ST) {
              role.sortBy = 1;
            } else if (x.id === this.roleIds.PA) {
              role.sortBy = 2;
            } else if (x.id === this.roleIds.TR) {
              role.sortBy = 3;
            } else if (x.id === this.roleIds.CO) {
              role.sortBy = 4;
            } else if (x.id === this.roleIds.ED) {
              role.sortBy = 5;
            }
            return role;
          });
        this.items = _.sortBy(this.items, "sortBy");
      })
      .catch((err) => {
        this.loading = false;
      });
  },
  watch: {
        email(val) {
            this.error.email.type = null;
        },
        name(val) {
            this.error.name.type = null;
        },
    },
};
</script>
